let openSearch = document.querySelectorAll(".open-search");
let openOverlay = document.querySelector(".search-overlay");
let closeSearch = document.querySelector(".close-search");
let searchInput = document.getElementById("Search");
let mainSearchForm = document.querySelector(".main-search-form");
let predictiveSearchForm = document.getElementById("predictive-search");
let defaultSearch = document.querySelector(".default-search-container");
let viewAllBtn = document.querySelectorAll(".mobile-cart-search-btn-container");

openSearch.forEach((element) => {
  element.addEventListener("click", () => {
    mainSearchForm.classList.add("main-search-form--visible");
    document.querySelector(".js").classList.add("page-locked");
    openOverlay.style.display = "block";
    if (searchInput.value.length < 1) {
      // If predictive search isn't already open
      defaultSearch.style.display = "block";
    } else {
      searchInput.value = "";
      predictiveSearchForm.style.display = "none";
      defaultSearch.style.display = "block";
    }
    searchInput.focus();
  });
});

openOverlay.addEventListener("click", () => {
  mainSearchForm.classList.remove("main-search-form--visible");
  document.querySelector(".js").classList.remove("page-locked");
  openOverlay.style.display = "none";
  defaultSearch.style.display = "none";
});

closeSearch.addEventListener("click", () => {
  mainSearchForm.classList.remove("main-search-form--visible");
  document.querySelector(".js").classList.remove("page-locked");
  openOverlay.style.display = "none";
  defaultSearch.style.display = "none";
});

searchInput.addEventListener("input", () => {
  if (searchInput.value === "" || searchInput.value === null) {
    defaultSearch.style.display = "block";
  } else {
    defaultSearch.style.display = "none";
  }
});

// Adjust search position based on user scroll

function currentCoordinates() {
  const scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;

  const announcementBar = document.getElementById('AnnouncementBar');
  const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
  const header = document.querySelector("header");
  const headerHeight = header ? header.offsetHeight : 0;
  const mainSearchFormHeight = mainSearchForm ? mainSearchForm.offsetHeight : 0;

  if(scrollTop > announcementBarHeight) {
    mainSearchForm.style.top = headerHeight + 'px';
    defaultSearch.style.marginTop = scrollTop  + 'px';
  } else {
    mainSearchForm.style.top = '';
    defaultSearch.style.marginTop = '';
  }
}

currentCoordinates();
document.addEventListener("scroll", () => {
  currentCoordinates();
});

// Android menu/bezel at the bottom of the screen is a different height to IOS. Need to adjust button size to accomodate.

const getMobileOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return "Android";
  } else if (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    return "iOS";
  }
  return "Other";
};

const os = getMobileOS();

if (os === "Android") {
  viewAllBtn.forEach((element) => {
    element.style.minHeight = "125px";
  });
}
